<div class="page-container">
    <!-- <h2 class="title">博世汽车配件在线目录</h2> -->
    <div class="banner">
        <img src="assets/official-website/people-vehicle.png" class="banner-img" />
    </div>
    <div class="vin-box">
        <div class="section-title">VIN码搜索</div>
        <div class="input-row">
            <nz-input-group [nzSuffix]="isLoading ? loadingTpl : suffixTpl">
                <input nz-input type="text" class="vin-input" [(ngModel)]="vinCode" placeholder="请输入17位VIN码"
                    mask="AAAA AAAA AAAA AAAA A" [showMaskTyped]="true" placeHolderCharacter="_"
                    [dropSpecialCharacters]="true" (keydown.enter)="onHandleSearch()" />
            </nz-input-group>

            <ng-template #suffixTpl>
                <div class="suffix-icons">
                    <!-- 查询 -->
                    <i nz-icon nzType="search" class="action-icon" style="margin-right: 10px;"
                        (click)="onHandleSearch()"></i>
                    <!-- 相机 -->
                    <!-- <i nz-icon nzType="camera" class="action-icon camera-icon" (click)="openCamera(cameraInput)"></i> -->
                </div>
            </ng-template>

            <ng-template #loadingTpl>
                <i nz-icon nzType="loading"></i>
            </ng-template>

            <div *ngIf="vinError" class="error-message">
                VIN码必须为17位字符
            </div>
        </div>
        <div class="agree-row">
            <input type="checkbox" id="privacy" [(ngModel)]="privacyAgreed">
            <label for="privacy" style="margin-left: 5px;">
                我已阅读并同意关于VIN码搜索的
            </label>
            <span class="link" style="margin-left: 5px; font-weight: 400; font-size: 14px;" (click)="onHandlePrivacy()">
                隐私条款
            </span>
        </div>
    </div>
    <div class="menu-grid">
        <div class="menu-item" style="background-color: #007BC0;" (click)="openSeachByCarPage()">
            <img width="106px" src="assets/ecat/car.png" />
            <div class="menu-label">按车型</div>
        </div>
        <div class="menu-item" style="background-color: #00884A;" (click)="openCamera(cameraInput)">
            <img width="79px" src="assets/ecat/camera.png" />
            <div class="menu-label">拍照搜索</div>
        </div>
        <div class="menu-item" style="background-color: #9E2896;" (click)="fileInput.click()">
            <img width="55px" src="assets/ecat/mobile.png" />
            <div class="menu-label">图片识别</div>
        </div>
        <div class="menu-item" style="background-color: #18837E;" (click)="openSeachByProductPage()">
            <img width="92px" src="assets/ecat/product.png" />
            <div class="menu-label">产品搜索</div>
        </div>
    </div>
    <nz-modal [(nzVisible)]="isPrivacyVisible" nzTitle="提示" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
        <ng-container *nzModalContent>
            <p style="margin: 20px 0;">
                当您使用【个人车辆信息：车辆VIN码】搜索相关配件时，请确保您已经过车主授权提供此信息给我们的【博世汽车配件在线目录】。如需查看详细的博世（中国）个人信息保护政策，请点击位于页面底部的“隐私”链接进行查看。
            </p>
        </ng-container>
    </nz-modal>
    <!-- <nz-modal [(nzVisible)]="isUploadVisible" nzTitle="上传VIN码照片" (nzOnCancel)="handleUploadCancel()"
    (nzOnOk)="handleUploadOk()">
    <ng-container *nzModalContent>
        <nz-upload class="upload-vin" nzType="drag" [nzCustomRequest]="handleChange">
            <p class="ant-upload-drag-icon">
                <i nz-icon nzType="cloud-upload"></i>
            </p>
            <p class="ant-upload-hint">
                点击上传VIN码照片
            </p>
        </nz-upload>
    </ng-container>
</nz-modal> -->
    <input type="file" #fileInput style="display: none;" accept="image/*" (change)="onFileSelected($event)" />
    <input #cameraInput type="file" accept="image/*" capture="environment" hidden (change)="onFileSelected($event)" />
    <!-- <div *ngIf="showVideo">
    <video [src]="videoSrc" controls style="width: 100%; max-width: 600px; margin-top: 20px;"></video>
</div> -->